module.exports = __webpack_public_path__ + "media/images/fallback/figures/default-be6cdecab6846cc56353b139a39c03dd.png";